import { useField } from 'formik';
import { SelectableTabs, SelectableTabsOptionType } from '@/components/form/fields/SelectableTabs/SelectableTabs';
import { ReactNode } from 'react';
import { getFieldError } from '@/helpers/formHelpers/formHelpers';
import { ResponseErrorType } from '@/types/sharedTypes';

interface FormikSelectableTabsType {
  name: string;
  options: ReadonlyArray<SelectableTabsOptionType>;
  label?: ReactNode;
  disabled?: boolean;
  direction?: 'row' | 'column';
  apiError?: ResponseErrorType;
  hasErrorComponent?: boolean;
}

export const FormikSelectableTabs = ({
  label,
  name,
  options,
  disabled,
  direction,
  apiError,
  hasErrorComponent,
}: FormikSelectableTabsType) => {
  const [field, meta, { setValue }] = useField(name);

  const { error, apiError: apiErrorMessage } = getFieldError(name, meta, apiError);

  const handleSelect = (value: string) => {
    setValue(value);
  };

  return (
    <SelectableTabs
      {...field}
      direction={direction}
      label={label}
      value={field.value}
      onSelect={handleSelect}
      options={options}
      disabled={disabled}
      hasErrorComponent={hasErrorComponent}
      error={error}
      apiError={apiErrorMessage}
    />
  );
};
